export default __webpack_public_path__ + "static/cover-63c65475bccb78dc272cb6f3001f835a.png";